'use client';

import { useTransition, useEffect } from 'react';
import { useIntlRouter } from 'i18n/routing';
import { usePageLoader } from 'providers/loader';

export function useEnhancedRouter() {
  const router = useIntlRouter();
  const [isPending, startTransition] = useTransition();
  const { showLoader, hideLoader } = usePageLoader();

  useEffect(() => {
    if (!isPending) {
      hideLoader();
      return;
    }

    showLoader();

    // The caller may be unmounted by its own navigation, so release the loader here too.
    return () => hideLoader();
  }, [isPending]);

  const push = (...args: Parameters<typeof router.push>) => {
    startTransition(() => {
      router.push(...args);
    });
  };

  const replace = (...args: Parameters<typeof router.replace>) => {
    startTransition(() => {
      router.replace(...args);
    });
  };

  return {
    ...router,
    push,
    replace,
  };
}
